import * as Sentry from '@sentry/react';

/**
 * Initialize Sentry from a DSN supplied via env. If the DSN is missing we
 * silently no-op — useful in local dev where you don't want to send events,
 * and on fresh deploys before you've pasted the DSN in Vercel.
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    // Conservative defaults — Haphe is small and traffic is cheap.
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: import.meta.env.MODE === 'production' ? 1.0 : 0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Don't ship local-only errors
    beforeSend(event) {
      if (event.exception?.values?.[0]?.value?.includes('AbortError')) return null;
      return event;
    },
  });
}

export { Sentry };
